import FormFieldViewText from "components/FormFields/ViewText";
import { BlobStorageIntegration, BlobStorageSubtype } from "types/generated";
import { BLOB_STORAGE_SUBTYPE_LABELS } from "views/Account/VCS/Integrations/ManageBlobStorage/helpers";

type VCSIntegrationsDetailsBlobStorageProps = {
  details: BlobStorageIntegration;
};

const VCSIntegrationsDetailsBlobStorage = ({ details }: VCSIntegrationsDetailsBlobStorageProps) => {
  const isAwsS3 = details.subtype === BlobStorageSubtype.AwsS3;

  return (
    <>
      <FormFieldViewText
        label="Storage subtype"
        value={BLOB_STORAGE_SUBTYPE_LABELS[details.subtype]}
      />

      <FormFieldViewText label="Base URI" value={details.baseURI} />

      {isAwsS3 && details.region && <FormFieldViewText label="Region" value={details.region} />}

      {isAwsS3 && details.roleArn && <FormFieldViewText label="Role ARN" value={details.roleArn} />}

      {isAwsS3 && details.externalId && (
        <FormFieldViewText
          label="External ID"
          value={details.externalId}
          withCopy
          tooltipInfo="Use this Spacelift-generated External ID in the assumed role's trust policy."
          tooltipWidthMode="maxWidthSm"
        />
      )}

      {!isAwsS3 && details.endpoint && (
        <FormFieldViewText label="Endpoint URL" value={details.endpoint} />
      )}

      {!isAwsS3 && details.accessKeyId && (
        <FormFieldViewText label="Access key ID" value={details.accessKeyId} />
      )}

      <FormFieldViewText
        label="Credentials"
        value={details.hasCredentials ? "Configured" : "Public bucket (none)"}
      />
    </>
  );
};

export default VCSIntegrationsDetailsBlobStorage;
